import { render, staticRenderFns } from "./Forbiden.vue?vue&type=template&id=21d4c5b5&scoped=true"
import script from "./Forbiden.vue?vue&type=script&lang=js"
export * from "./Forbiden.vue?vue&type=script&lang=js"
import style0 from "./Forbiden.vue?vue&type=style&index=0&id=21d4c5b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d4c5b5",
  null
  
)

export default component.exports